import React from 'react';
import { FormLabel } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { IVenue } from '../models/Venue';
import { observer } from 'mobx-react';

interface OptionType {
  value: string;
  label: string;
}

interface VenueSelectionDropdownProps {
  assignedVenues: string[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  venues: IVenue[];
  className?: string;
  classNamePrefix?: string;
  fieldName: string;
}

export const VenueSelectionDropdown: React.FC<VenueSelectionDropdownProps> = observer(({
  assignedVenues,
  setFieldValue,
  venues,
  className = "react-select-container react-select-container-benefits-statuses",
  classNamePrefix = "react-select",
  fieldName
}) => {
  const { t } = useTranslation();

  const options: OptionType[] = venues.map(venue => ({
    value: venue.id,
    label: venue.name || venue.id // Fallback to ID if name is undefined
  }));

  const onChange = (selectedOptions: OptionType[] | null) => {
    const selectedStatusIds = (selectedOptions ?? []).map(option => option.value);
    setFieldValue(fieldName, selectedStatusIds);
  };

  const currentValue: OptionType[] = options.filter(option =>
    assignedVenues.includes(option.value)
  );

  return (
    <div>
      <FormLabel className="textInputLabel">{t('rewardModifyScreen.availableTo')}</FormLabel>
      <Select
        isMulti
        options={options}
        onChange={onChange}
        value={currentValue}
        className={className}
        classNamePrefix={classNamePrefix}
        placeholder={t("rewardModifyScreen.allVenues")}
      />
    </div>
  );
});

export default VenueSelectionDropdown; 